module.exports = __webpack_public_path__ + "img/save.71ce4afb.svg";